import { render, staticRenderFns } from "./ExtratoAssociadoModule.vue?vue&type=template&id=28b0ff7e"
import script from "./ExtratoAssociadoModule.vue?vue&type=script&lang=js"
export * from "./ExtratoAssociadoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports